import React from 'react';
import { Select, SelectProps, Typography } from 'antd';
import { isNil, noop } from 'lodash';
import { useQuery } from 'react-query';
import {
  getThirdPartyBkAccountListByTpid,
  GetThirdPartyBkAccountListByTpidParams,
  TpBankAccountResponse2,
} from 'services/thirdParty';

export type BankAccountListSelectProps = SelectProps<any> & {
  value?: any;
  params: GetThirdPartyBkAccountListByTpidParams & {
    allowedBktype?: Array<string>;
  };
  onChange?: (BankAccount: TpBankAccountResponse2) => void;
  onSelected?: (BankAccount: TpBankAccountResponse2) => void;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
  display?: boolean;
  displayStyle?: React.CSSProperties;
};

const BankAccountListSelect = ({
  value,
  params,
  onChange = noop,
  onSelected,
  display,
  displayStyle,
  ...otherProps
}: BankAccountListSelectProps) => {
  const { data: BankAccount, isLoading } = useQuery(
    ['getThirdPartyBkAccountListByTpid', params],
    () =>
      getThirdPartyBkAccountListByTpid({ tpid: params.tpid }).then((res) => {
        if (params?.allowedBktype) {
          return res.list.filter(
            (e) =>
              e.bkstatus === 'VALID' &&
              params?.allowedBktype?.includes(e.bktype)
          );
        } else return res.list.filter((e) => e.bkstatus === 'VALID') || [];
      }),
    { enabled: !isNil(params.tpid) }
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value);
    if (onSelected) {
      onSelected(BankAccount?.find((item) => item.tpbkid === value)!);
    }
  };

  return display ? (
    <Typography.Text style={displayStyle}>
      {BankAccount?.find(
        (bk) =>
          bk.tpbkid ===
          (typeof value === 'object' ? value.tpbkid : Number(value))
      )?.tpbankname +
        ' - ' +
        BankAccount?.find(
          (bk) =>
          bk.tpbkid ===
            (typeof value === 'object' ? value.tpbkid : Number(value))
        )?.tpiban}
    </Typography.Text>
  ) : (
    <Select
      onChange={handleChange}
      {...otherProps}
      loading={isLoading}
      allowClear
      value={value}
    >
      {BankAccount?.map((bankAcc) => (
        <Select.Option value={bankAcc.tpbkid} key={bankAcc.tpbkid}>
          {bankAcc.tpbankname + ' - ' + bankAcc.tpiban}
        </Select.Option>
      ))}
    </Select>
  );
};

export default BankAccountListSelect;
